module.exports = __webpack_public_path__ + "img/mgm.20796aa1.svg";